"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Box = _interopRequireDefault(require("./Box"));
var _mixins = require("../mixins");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Section = (0, _styledComponents["default"])(_Box["default"]).attrs(function (props) {
  return {
    w: props.w || props.width || "100%",
    h: props.h || props.height,
    minW: props.minW || props.minWidth,
    maxW: props.maxW || props.maxWidth,
    minH: props.minH || props.minHeight,
    maxH: props.maxH || props.maxHeight
  };
}).withConfig({
  displayName: "Section",
  componentId: "sc-nakqfh-0"
})(["", ";padding:", ";", ";", ";"], _mixins.noMarginLastChild, function (props) {
  return props.theme.spaces.base;
}, _mixins.paddingMixin, function (props) {
  return props.separator && (0, _styledComponents.css)(["", ";"], (0, _mixins.separatorMixin)(props, props.separator === true ? "bottom" : props.separator));
});
Section.displayName = "Section";
var _default = Section;
exports["default"] = _default;